module.exports = __webpack_public_path__ + "img/classic_6.bb2617b7.png";